import {
  BooleanField,
  BooleanInput,
  ChipField,
  Datagrid,
  DeleteWithConfirmButton,
  EditButton,
  List,
  ListProps,
  TextField,
  TextInput,
  useListController,
  WithRecord,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";

export const ListCategories: React.FC<ListProps> = (props) => {
  const listContext = useListController();

  const filters = [
    <TextInput key="name" label="Nombre" source="name" alwaysOn />,
    <BooleanInput
      key="isRoot"
      label="Es Raiz"
      source="isRoot"
      alwaysOn
      defaultValue={false}
      format={(value) => {
        if (typeof value === "string") {
          return value === "true";
        }
        return Boolean(value);
      }}
      parse={(value) => {
        if (typeof value === "string") {
          return value === "true";
        }
        return Boolean(value);
      }}
    />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <TextField source="name" label="Nombre" />
        <BooleanField source="isRoot" label="Es Raiz" />
        {!listContext.filterValues.isRoot && (
          <ChipField
            source="parent.name"
            label="Categoría Padre"
            sortable={false}
            emptyText="N/A"
          />
        )}
        <WithRecord
          render={(record) => {
            const deleteTitle = `Eliminar categoria: ${record.name}`;
            return (
              <>
                <EditButton label="Editar" />
                <DeleteWithConfirmButton
                  mutationMode="pessimistic"
                  confirmTitle={deleteTitle}
                  confirmContent="¿Está seguro que desea eliminar esta categoria? Esta acción no se puede deshacer."
                  record={record}
                  label="Eliminar"
                />
              </>
            );
          }}
        ></WithRecord>
      </Datagrid>
    </List>
  );
};
